import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserProfileViewModel } from '../models/main/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class UserProfileStore {

  private readonly USER_PROFILE_KEY: string = "UserProfile";
  private readonly _profile = new BehaviorSubject<UserProfileViewModel | null>(null);
  userProfile$ = this._profile.asObservable();

  setUserProfile(userProfile: UserProfileViewModel) {
    userProfile.profiles=[{ "profile": "Admin", "scope": ["RE/ES", "DP/ES", "DS/ES", "SS/ES"] }];
    userProfile.optimizedMode=true;
    sessionStorage.setItem(this.USER_PROFILE_KEY, JSON.stringify(userProfile));    
      this._profile.next(userProfile); // Emit the new value to subscribers    
  }

  getUserProfile(): UserProfileViewModel | null {
    const userProfile: UserProfileViewModel = JSON.parse(sessionStorage.getItem(this.USER_PROFILE_KEY));
    return userProfile;
  }

  clearUserProfile() {
    sessionStorage.removeItem(this.USER_PROFILE_KEY);
    this._profile.next(null);
  }
}
